module.exports = __webpack_public_path__ + "static/media/Button_X.f57a050f.png";